//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import channelTypesMixin from '@motionelements/core/src/components/mixins/channelTypes.mixin.js';

export default {
  name: 'SectionFreeButtons',
  mixins: [channelTypesMixin],
  props: {
    mediaType: {
      type: String,
      default: 'video_free',
    },
  },
  components: {
    // ProductIcon,
    FreeButton: () => import('@motionelements/core/src/components/product/FreeButton.vue'),
  },
};
